import { QuestionAnswerMap } from '@care-portals/api-interfaces';

export const constipationQuestions = [
  {
    field: 'constipation_sexAssignedAtBirth',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Male', key: 'male' },
        { value: 'Female', key: 'female' }
      ]
    }
  },
  {
    field: 'constipation_nonConsent',
    isLast: true,
    label: `We understand that you do not consent. Please seek in-person care and a refund will process between 5 - 10 business days`,
    extras: { sendToBeluga: false },
    blockQuestionFlow: true,
    type: 'info',
    answer: {}
  },
  {
    field: 'constipation_pregnancyStatus',
    label:
      'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_consentPregnancy',
    label: 'Consent (pregnancy):',
    type: 'select',
    educationalSlide:
      'I understand that the medication prescribed to me by my healthcare provider may not be safe to take during pregnancy. I acknowledge that taking this medication while pregnant could pose risks to my health and the health of a developing fetus.\n\nI agree to take necessary precautions to avoid becoming pregnant while using this medication, including the use of effective contraception methods as discussed with my healthcare provider.\n\nI understand that I should stop taking this medication before attempting to become pregnant. I agree to consult with my healthcare provider prior to discontinuing the medication and before planning a pregnancy to ensure my safety and well-being.\n\nBy selecting  below, I confirm that I have read and understand the information provided above. I consent to proceed with the treatment under these conditions.',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'No, I do not consent',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value: 'Yes, I have read and consent',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'constipation_height',
    label: 'What is your height in feet and inches?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 1,
      name: 'constipation_height'
    }
  },
  {
    field: 'constipation_weight',
    label: 'What is your weight in pounds?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 1,
      name: 'constipation_weight'
    }
  },
  {
    field: 'constipation_bloodInStool',
    label: 'Have you noticed blood in your stool or on the toilet paper?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_unexplainedWeightLoss',
    label: 'Have you had unexplained weight loss lately?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_anemic',
    label: 'Have you been told you are anemic or have low blood counts?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_bowelHabitChange',
    label: 'Have you had a sudden change in bowel habits in the past 3 months?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_bowelMovementsPerWeek',
    label: 'How many natural bowel movements do you have per week?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: '0–2', key: 'zero_to_two' },
        { value: '3–6', key: 'three_to_six' },
        { value: '7 or more', key: 'seven_or_more' }
      ]
    }
  },
  {
    field: 'constipation_hardStools',
    label: 'Are your stools often hard, small, or lumpy?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_incompleteEvacuation',
    label: "Do you feel you haven't completely emptied after a bowel movement?",
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_straining',
    label:
      'Do you usually need to strain or push hard to have a bowel movement?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_manualAssistance',
    label:
      'Do you ever use your fingers or a device to help have a bowel movement?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_blockageSensation',
    label:
      'Do you ever feel a blockage or something preventing stool from coming out?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_symptomDuration',
    label:
      'Have the symptoms lasted more than 6 months and occurred at least 25 % of the time (more than two days a week)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_bristolStoolType',
    label: 'On the Bristol Stool Chart, what is your usual stool type:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Type 1–2 (hard / pellet-like)', key: 'type_1_2' },
        { value: 'Type 3–5 (normal)', key: 'type_3_5' },
        { value: 'Type 6–7 (loose)', key: 'type_6_7' }
      ]
    }
  },
  {
    field: 'constipation_toiletTime',
    label:
      'Do you spend more than 10–15 minutes on the toilet actively trying to have a bowel movement?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_urgeCantGo',
    label: "Do you often feel the urge but can't go?",
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_laxativeUse',
    label:
      'How often do you use laxatives, enemas, suppositories, or fiber supplements?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Never', key: 'never' },
        { value: 'Occasionally', key: 'occasionally' },
        { value: 'Weekly', key: 'weekly' },
        { value: 'Daily', key: 'daily' }
      ]
    }
  },
  {
    field: 'constipation_fiberIntake',
    label:
      'Do you usually eat enough fruits, vegetables, and whole-grain fiber?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_waterIntake',
    label: 'What is your approximate water intake per day:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Less than 4 cups', key: 'less_than_4cups' },
        { value: '4-8 cups', key: '4_to_8cups' },
        { value: 'More than 8 cups', key: 'more_than_8cups' }
      ]
    }
  },
  {
    field: 'constipation_physicalActivity',
    label: 'How many days a week are you physically active?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: '0', key: 'zero' },
        { value: '1–3', key: 'one_to_three' },
        { value: '4 or more', key: 'four_or_more' }
      ]
    }
  },
  {
    field: 'constipation_hypothyroidism',
    label: 'Do you have Hypothyroidism (underactive thyroid)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_diabetes',
    label: 'Do you have diabetes?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_neurologicDisorders',
    label: "Do you have any neurologic disorders (e.g., MS, Parkinson's)?",
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_anorectalSurgery',
    label: 'Have you ever had anorectal surgery?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_pelvicFloorDysfunction',
    label:
      'Do you have pelvic-floor dysfunction or did you have childbirth trauma?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'constipation_additionalQuestions',
    label: 'What other information or questions do you have for the doctor?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'constipation_additionalQuestions'
    }
  },

  {
    field: 'constipation_consentTruthfulness',
    label: 'Consent (Truthfulness):',
    type: 'select',
    educationalSlide:
      'Please attest to the following confirming that all information you have provided to us is true and complete.\n\nI verify that I am the patient and that I have answered the questions asked in this intake form.  I confirm that I have reviewed and understood all the questions asked of me.  I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor.  I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'No, I do not consent',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value: 'Yes, I have read and consent',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'constipation_consentLubiprostone',
    label: 'Consent (Lubiprostone for Chronic Constipation):',
    type: 'select',
    educationalSlide:
      'You have reported symptoms consistent with chronic constipation, which may include infrequent bowel movements, straining, hard stools, a sensation of incomplete evacuation, or difficulty passing stool. When lifestyle modifications are not sufficient, prescription medications may be recommended to improve bowel motility and reduce discomfort. This consent form outlines the medications being recommended, their intended benefits, potential risks and side effects, alternative treatments, and your rights as a patient.\n\nYou are being prescribed one of the following options:\nPsyllium (Metamucil)\nDocusate sodium (Colace)\nPolyethylene glycol 3350 (Miralax)\nLactulose (Kristalose)\nMagnesium hydroxide (Milk of Magnesia)\nBisacodyl (Dulcolax)\nSenna (Senokot)\nLubiprostone (Amitiza)\nLinaclotide (Linzess)\nPlecanatide (Trulance)\nPrucalopride (Motegrity)\n\nBENEFITS These medications may help relieve constipation by softening stool, increasing bowel movement frequency, and improving overall comfort during defecation.\n\nRISKS AND SIDE EFFECTS Potential side effects may include:\nAbdominal cramping or pain\nBloating or gas\nDiarrhea or loose stools\nNausea or vomiting\nElectrolyte imbalances with prolonged use of certain laxatives\nDehydration if fluid intake is inadequate\nAllergic reactions (rare but possible)\n\nALTERNATIVE TREATMENTS\nDietary modifications (e.g., increased fiber and fluid intake)\nRegular physical activity\nBiofeedback therapy for pelvic floor dysfunction\nDigital disimpaction or enemas in refractory cases\nReferral to a gastroenterologist for further evaluation\n\nPATIENT RESPONSIBILITIES\nFollow the prescribed regimen and any additional instructions given by your provider\nReport any severe, persistent, or unexpected side effects promptly\nMaintain adequate hydration and a balanced diet rich in fiber\nAttend scheduled follow-up appointments\n\nI understand the potential benefits, risks, and side effects.. I agree to follow instructions for use and report any side effects or changes in symptoms.I understand that this consent is voluntary and that I may withdraw from treatment at any time.\n\nBy selecting below, I consent to the use of lubiprostone for the treatment of my constipation.',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'No, I do not consent',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value: 'Yes, I have read and consent',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'constipation_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'constipation_ineligible',
    label: "We're sorry you don't qualify.",
    subLabel:
      'Based on your responses, there are concerning signs that go beyond what can be safely managed remotely. Please seek in-person medical care as soon as possible. It’s important to rule out anything more serious and ensure you get the right treatment. A refund will process between 5 - 10 business days.',
    extras: { sendToBeluga: false },
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

const _type = [...constipationQuestions] as const;

export type ConstipationFieldAnswers = Partial<QuestionAnswerMap<typeof _type>>;

export default constipationQuestions;
